import { partA } from "./partA";
import { partB } from "./partB";
import { partC } from "./partC";

export const LESSON_QUIZZES = { ...partA, ...partB, ...partC };

export const getLessonQuiz = (path, lang) => {
  const q = LESSON_QUIZZES[path];
  return q ? q[lang] || q.en : null;
};

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const shuffleQuiz = (questions) =>
  questions.map((q) => {
    const idx = shuffle(q.o.map((_, i) => i));
    return { ...q, o: idx.map((i) => q.o[i]), a: idx.indexOf(q.a) };
  });
